export default "__VITE_ASSET__ByxBb999__"